import { useCallback, useEffect, useState } from "react";

const KEY = "helcoo.scope";

const read = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
};

// يتذكّر آخر فرع وموظف اختارهما المستخدم ليفتح التطبيق عليهما تلقائياً.
export const useSavedScope = (extra = {}) => {
  const saved = read();
  const [filters, setFilters] = useState({
    branch_id: saved.branch_id || "",
    user_id: saved.user_id || "",
    ...extra,
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify({ branch_id: filters.branch_id, user_id: filters.user_id }));
  }, [filters.branch_id, filters.user_id]);

  const update = useCallback((next) => setFilters((prev) => ({ ...prev, ...next })), []);
  return [filters, setFilters, update];
};

export const savedScope = read;
